import React from 'react';
import {Route, Switch, BrowserRouter, Redirect} from 'react-router-dom';
import {Provider} from 'react-redux';
import Header from './components/Header/index';
import Loader from './components/Loader/index';
import store from './store';
import CreateSchedule from './pages/CreateSchedule/index';
import CreateCalendar from '../src/pages/CreateCalendar/index';
import PickupSlot from '../src/pages/PickupSlot/index';
import FinalPage from '../src/pages/FinalPage/index';
import RedirectHandler from '../src/components/RedirectHandler/index';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

const CREATE_CALENDAR = '/doas-surplus';
const CREATE_SCHEDULE = '/surplus/:guid';
const PICKUP_SLOT = '/buyer/:guid';
const FINAL = '/final';

const Root = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Header />
        <Loader />
        <RedirectHandler />
        <Switch>
          <Route exact path={'/'}>
            <Redirect to={CREATE_CALENDAR}/>
          </Route>
          <Route exact path={CREATE_CALENDAR} component={CreateCalendar} />
          <Route exact path={CREATE_SCHEDULE} component={CreateSchedule} />
          <Route exact path={PICKUP_SLOT} component={PickupSlot} />
          <Route exact path={FINAL} component={FinalPage} />
        </Switch>
      </Provider>
    </BrowserRouter>
  );
};

export default Root;